import React, { useState } from "react";
import ReactDOM from "react-dom";
import BusinessModal, { BusinessOfferForm } from "../business_pages/components/BusinessForm";
import SuccessModal from "../business_pages/components/SuccessModal";

// Mount points rendered by CmsShortcodesHelper for [business_form_button] and [business_form].

// color="blue" in the shortcode -> the global .cms-button-blue CTA style (service_pages.scss)
const buttonClassName = (color?: string) =>
  color === "blue" ? "cms-button-blue" : "btn btn-primary-alsendo btn-lg btn-circle";

const BusinessFormButton = ({ text, color }) => {
  const [isFormModalVisible, setIsFormModalVisible] = useState(false);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);

  return (
    <>
      <button
        className={buttonClassName(color)}
        onClick={() => setIsFormModalVisible(true)}
      >
        {text}
      </button>
      {isFormModalVisible && (
        <BusinessModal
          setIsFormModalVisible={setIsFormModalVisible}
          setIsSuccessModalVisible={setIsSuccessModalVisible}
        />
      )}
      {isSuccessModalVisible && (
        <SuccessModal setIsSuccessModalVisible={setIsSuccessModalVisible} />
      )}
    </>
  );
};

const InlineBusinessForm = ({ color }) => {
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);

  return (
    <>
      <BusinessOfferForm
        buttonClassName={buttonClassName(color)}
        onSuccess={() => setIsSuccessModalVisible(true)}
      />
      {isSuccessModalVisible && (
        <SuccessModal setIsSuccessModalVisible={setIsSuccessModalVisible} />
      )}
    </>
  );
};

document.querySelectorAll<HTMLElement>(".js-cms-business-form-button").forEach((node) => {
  ReactDOM.render(<BusinessFormButton text={node.dataset.text} color={node.dataset.color} />, node);
});

document.querySelectorAll<HTMLElement>(".js-cms-business-form").forEach((node) => {
  ReactDOM.render(<InlineBusinessForm color={node.dataset.color} />, node);
});
